//定位信息
export default {
  //namespaced 开启namespaced
  namespaced: true,
  //action 响应组件动作 逻辑写在这
  actions: {

  },
  //mutation 处理数据 不要写逻辑
  mutations: {

  },
  //state 数据/状态
  state: {
    //打卡地点数据
    signCheckLocation: {
      address: '', //完整地址
      country: '', //国家
      province: '', //省
      city: '', //市
      district: '', //县、区
      township: '', //村镇
      street: '', //街道
      streetNumber: '', //街道号
      lat: '', //纬度
      lng: '', //经度
    },
  },
  //getters 用于state后续数据加工
  getters: {

  },
}